import { __extends } from "tslib";
import { GetSegmentVersionsRequest, GetSegmentVersionsResponse } from "../models/models_1";
import { deserializeAws_restJson1GetSegmentVersionsCommand, serializeAws_restJson1GetSegmentVersionsCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var GetSegmentVersionsCommand = /** @class */ (function (_super) {
    __extends(GetSegmentVersionsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetSegmentVersionsCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    GetSegmentVersionsCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "PinpointClient";
        var commandName = "GetSegmentVersionsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: GetSegmentVersionsRequest.filterSensitiveLog,
            outputFilterSensitiveLog: GetSegmentVersionsResponse.filterSensitiveLog,
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetSegmentVersionsCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1GetSegmentVersionsCommand(input, context);
    };
    GetSegmentVersionsCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1GetSegmentVersionsCommand(output, context);
    };
    return GetSegmentVersionsCommand;
}($Command));
export { GetSegmentVersionsCommand };
//# sourceMappingURL=GetSegmentVersionsCommand.js.map